import { render, staticRenderFns } from "./confirm-poptip.vue?vue&type=template&id=1afafb6b&"
import script from "./confirm-poptip.vue?vue&type=script&lang=js&"
export * from "./confirm-poptip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports